<ng-container *transloco="let t;">
  @for(accountManager of dealersByAccountManager; track accountManager.value) {
    <div class="mb-2">
      <div class="account-manager-dropdown">
        <app-search-filter-section
          title="{{ accountManager.name }}"
          variant = "link"
          [analyticsName]="'Account Manager Name (accordion)'"
          [open]="isAccountManagerDropdownOpen(accountManager.value)"
          (openChange)="toggleAccountManagerDropdown(accountManager.value)"
        >
        </app-search-filter-section>
      </div>
      @if (isAccountManagerDropdownOpen(accountManager.value)) {
        <div class="material-checkbox ms-2">
          @if (accountManagerTerm(accountManager)?.length >= searchThreshold) {
            <!-- Search Input -->
            <div class="form-group mb-3">
              <label
                [for]="'dealer-search-' + accountManager.value"
                class="text-uppercase d-block">
                {{ t('common.labelSearch') }}
              </label>
              <div class="search-input-container">
                <input
                  [id]="'dealer-search-' + accountManager.value"
                  type="text"
                  class="form-control"
                  [placeholder]="''"
                  [attr.data-test-id]="'app-dealer-search-input-' + accountManager.value"
                  [ngModel]="getSearchTerm(accountManager.value)"
                  (input)="search($event, accountManager.value)"
                  (keydown.enter)="stopPropagation($event)"
                  (change)="stopPropagation($event)"/>
                @if (getSearchTerm(accountManager.value)) {
                  <button
                    type="button"
                    class="search-input-clear"
                    [attr.aria-label]="t('common.altClearSearchInput')"
                    (click)="clearSearch($event, accountManager.value)"
                    [attr.data-test-id]="'app-dealer-clear-search-' + accountManager.value">
                    <img
                      src="../../../../ui/assets/assets-{{ tenantName$() }}/{{ tenantName$() }}-close.svg"
                      [alt]="t('common.altClearSearchInput')" />
                  </button>
                }
              </div>
            </div>
          }
          @if(getVisibleDealers(accountManager.value)?.length > 1) {
            <div class="employee-item">
              <mat-checkbox class="_mat-animation-noopable"
                [checked]="isSelectAllChecked(accountManager.value)"
                [disableRipple]="true"
                (click)="toggleSelectAll(accountManager.value)"
                [attr.data-test-id]="'app-employee-selected-checkbox-select-all'"
                [aria-label]="t('common.selectAll')">
                {{ t('common.selectAll') }}
              </mat-checkbox>
            </div>
          }
          @for(employee of getVisibleDealers(accountManager.value); track employee.value) {
            <div class="employee-item">
              <mat-checkbox class="_mat-animation-noopable"
                [checked]="isDealerChecked(accountManager.value, employee.value)"
                [disableRipple]="true"
                (click)="toggleEmployee(accountManager.value, employee.value)"
                [attr.data-test-id]="'app-employee-selected-checkbox-' + employee.value"
                [aria-label]="employee.name">
                {{ employee.name }}
              </mat-checkbox>
            </div>
          }

          <!-- Show More / Show Less Button -->
          @if (shouldShowToggleButton(accountManager.value)) {
            @if (hasMoreItems(accountManager.value)) {
              <button
                type="button"
                class="btn btn-link p-0 mt-2 show-more-btn"
                (click)="showMore($event, accountManager.value)"
                [attr.data-test-id]="'app-dealer-show-more-btn-' + accountManager.value">
                {{ t('common.btnShowMore') }}
              </button>
            } @else if (canShowLess(accountManager.value)) {
              <button
                type="button"
                class="btn btn-link p-0 mt-2 show-less-btn"
                (click)="showLess($event, accountManager.value)"
                [attr.data-test-id]="'app-dealer-show-less-btn-' + accountManager.value">
                {{ t('common.btnShowLess') }}
              </button>
            }
          }
        </div>
      }
    </div>
  }
</ng-container>
